var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBicycleblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5436 2.30469H15.3008V10.0717H16.5436V2.30469Z",
    fill: "#201F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9237 8.20675C17.039 8.20675 17.9431 7.30264 17.9431 6.18736C17.9431 5.07208 17.039 4.16797 15.9237 4.16797C14.8084 4.16797 13.9043 5.07208 13.9043 6.18736C13.9043 7.30264 14.8084 8.20675 15.9237 8.20675Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9229 7.70123C16.7594 7.70123 17.4376 7.02308 17.4376 6.18655C17.4376 5.35002 16.7594 4.67188 15.9229 4.67188C15.0864 4.67188 14.4082 5.35002 14.4082 6.18655C14.4082 7.02308 15.0864 7.70123 15.9229 7.70123Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5017 2.92649H14.242L12.6886 1.5806H6.81055V0.337891H13.1521L14.7056 1.68378H17.0381L18.5915 0.337891H25.0369V1.5806H19.0551L17.5017 2.92649Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8227 22.9647H17.58V12.0909C17.58 11.1201 16.7903 10.3306 15.8197 10.3306C14.8488 10.3306 14.0591 11.1201 14.0591 12.0909V22.9647H12.8164V12.0909C12.8164 10.435 14.1638 9.08789 15.8197 9.08789C17.4756 9.08789 18.8227 10.4349 18.8227 12.0909V22.9647Z",
    fill: "#ABABAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9489 0H6.21289V1.94176H10.9489V0Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7848 0H21.0488V1.94176H25.7848V0Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1307 31.999H15.5101C15.1345 31.999 14.8301 31.6946 14.8301 31.319V13.1839C14.8301 12.8083 15.1345 12.5039 15.5101 12.5039H16.1307C16.5062 12.5039 16.8106 12.8083 16.8106 13.1839V31.319C16.8106 31.6945 16.5062 31.999 16.1307 31.999Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8307 21.748H14.0605V22.1747H14.8307V21.748Z",
    fill: "#666666"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8156 21.748H11.4238V22.1747H12.8156V21.748Z",
    fill: "#666666"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3762 26.5762H10.9844V27.0028H12.3762V26.5762Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5807 21.748H16.8105V22.1747H17.5807V21.748Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2141 21.748H18.8223V22.1747H20.2141V21.748Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1711 17.0117H19.7793V17.4384H21.1711V17.0117Z",
    fill: "#666666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4026 21.4121H11.6777V27.0057H12.4026V21.4121Z",
    fill: "#212121"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8792 17.0117H19.1543V22.6053H19.8792V17.0117Z",
    fill: "#212121"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4199 25.8066H9.08984V27.7744H11.4199V25.8066Z",
    fill: "#666666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5449 16.2402H20.2148V18.208H22.5449V16.2402Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleblack);
export default __webpack_public_path__ + "static/media/bicycleblack.78eca1dc133ce277e9b65b3e40dd0ec4.svg";
export { ForwardRef as ReactComponent };